import React from "react";

export default function OrdersDetail()  {
  return (
    <React.Fragment>
    </React.Fragment>
  );
}
